export default {
  // auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/password-reset/request',
  EMAIL_AVAILABILITY: '/auth/email-check-availability',
  CHANGE_PASSWORD: (userId) => {
    return `/users/${userId}/password-change`;
  },
  SERVICES_REQUESTS: '/services',
  SERVICES_REQUESTS_ID: (id) => {
    return `/services/${id}`;
  },
  ITEMS: '/items',
  ITEMS_LOG: '/item-log',
  ITEMS_ID: (id) => {
    return `/items/${id}`;
  },
  POS_STATIONS: '/service-station',
  POS_STATIONS_ID: (id) => {
    return `/service-station/${id}`;
  },
  VENDORS: '/vendors',
  VENDORS_ID: (id) => {
    return `/vendors/${id}`;
  },
  SHELFS: '/shelfs',
  SHELFS_ID: (id) => {
    return `/shelfs/${id}`;
  },
  JOB_RATES: '/job-rates',
  JOB_RATES_ID: (id) => {
    return `/job-rates/${id}`;
  },
  PM_CHECKS: '/pm-checks',
  PM_CHECKS_ID: (id) => {
    return `/pm-checks/${id}`;
  },
  WORK_ORDER: '/workorders',
  WORK_ORDER_ID: (id) => {
    return `/workorders/${id}`;
  },
  WORK_ORDER_SIGNATURE: '/work-order-signature',
  WORK_ORDER_ITEM: '/work-order-item',
  WORK_ORDER_KPI_DETAIL_APPROVAL: '/work-order-kpi-details-approval',
  WORK_ORDER_SIGNATURE_ID: (id) => {
    return `/work-order-signature/${id}`;
  },
  WORK_TYPE: '/work-type',
  WORK_TYPE_ID: (id) => {
    return `/work-type/${id}`;
  },
  EMPLOYEES: '/employees',
  EMPLOYEES_ID: (id) => {
    return `/employees/${id}`;
  },
  GRADES: '/grades',
  GRADES_ID: (id) => {
    return `/grades/${id}`;
  },
  ASSETS: '/assets',
  ASSETS_ID: (id) => {
    return `/assets/${id}`;
  },
  ASSETS_CATEGORY: '/asset-category',
  ASSETS_CATEGORY_ID: (id) => {
    return `/asset-category/${id}`;
  },
  DEPARTMENTS: '/departments',
  DEPARTMENTS_ID: (id) => {
    return `/departments/${id}`;
  },
  CLASSIFICATIONS: '/classifications',
  CLASSIFICATIONS_ID: (id) => {
    return `/classifications/${id}`;
  },
  UPLOAD_CSV: '/upload-csv',
  UPLOAD: '/upload',
  IMAGES: '/images',
  NOTIFICATIONS: '/notifications',
  HOT_SALES: '/hotsales',
  SALES: '/sales',
  SALES_ID: (id) => {
    return `/sales/${id}`;
  },
  WORK_ORDER_DETAIL: (id) => {
    return `/work-order-details/${id}`;
  },
  CONTRACT_CHARGE_APPROVAL: (id) => {
    return `/generate/contract-car/${id}`;
  },
  CONTRACTS: '/contracts',
  CONTRACTS_ID: (id) => {
    return `/contracts/${id}`;
  },
  CONTRACT_WORK_ORDER: '/contract-work-orders',
  CHARGE_APPROVAL_TRACKING: '/charge-approval-tracking',
  CHARGE_APPROVAL_TRACKING_ID: (id) => {
    return `/charge-approval-tracking/${id}`;
  },
  CHARGE_APPROVAL: '/charge-approval-status',
  CHARGE_APPROVAL_EMAIL: (id) => {
    return `/charge-approval-status/mail/${id}`;
  },
  CHARGE_APPROVAL_ID: (id) => {
    return `/charge-approval-status/${id}`;
  },
  INVOICES: '/invoices',
  INVOICES_EXCEL: '/invoices-report',
  INVOICES_EXCEL_DETAIL: (id) => {
    return `/invoice-details/${id}`;
  },
  INVOICES_ID: (id) => {
    return `/invoices/${id}`;
  },
  UNITS: '/units',
  UNITS_ID: (id) => {
    return `/units/${id}`;
  },
  PURCHASE_ORDERS_ARRIVAL: '/purchase-order-item-arrival',
  PURCHASE_ORDERS_ARRIVAL_ID: (id) => {
    return `/purchase-order-item-arrival/${id}`;
  },
  PURCHASE_ORDERS_APPROVAL: '/purchase-order-approval',
  PURCHASE_ORDERS_APPROVAL_ID: (id) => {
    return `/purchase-order-approval/${id}`;
  },
  PURCHASE_ORDERS: '/purchase-orders',
  PURCHASE_ORDERS_ITEMS: '/purchase-orders-items',
  PURCHASE_ORDERS_ID: (id) => {
    return `/purchase-orders/${id}`;
  },
  CHARGE_APPROVAL_SIGNATURE: '/charge-approval-signature',
  CHARGE_APPROVAL_SIGNATURE_ID: (id) => {
    return `/charge-approval-signature/${id}`;
  },
  CONTRACTORS: '/contractors',
  CONTRACTORS_ID: (id) => {
    return `/contractors/${id}`;
  },
  HOLIDAYS: '/holidays',
  HOLIDAYS_ID: (id) => {
    return `/holidays/${id}`;
  },
  ACCOUNTS: '/users',
  ACCOUNTS_ID: (id) => {
    return `/users/${id}`;
  },
  VOUCHERS: '/vouchers',
  VOUCHERS_ID: (id) => {
    return `/vouchers/${id}`;
  },
  ACCOUNTING: '/accounting',
  ACCOUNTING_ID: (id) => {
    return `/accounting/${id}`;
  },
  TIMESHEETS: '/timesheets',
  TIME_SHEETS_IMPORT: '/import/timesheets',
  TIMESHEETS_ID: (id) => {
    return `/timesheets/${id}`;
  },
  PAYROLL_EMPLOYEE: (employeeId) => {
    return `/payroll/${employeeId}`;
  },
  PAYROLL_EMPLOYEE_COMPLETE: (employeeId) => {
    return `/payroll/complete/${employeeId}`;
  },
  PAYROLL_IMPORT: '/import/payroll',
  PAYROLL_EXPORT: '/export/payroll',
  CAR_WASH: '/car-wash',
  CAR_WASH_BASE: '/car-wash/base',
  CAR_WASH_ID: (id) => {
    return `/car-wash/${id}`;
  },
  REQUEST_ITEM: '/request-item',
  REQUEST_ITEM_ID: (id) => {
    return `/request-item/${id}`;
  },
  CHARGE_APPROVAL_WORK_ORDER: '/charge-approval-work-orders',
  CHARGE_APPROVAL_WORK_ORDER_ID: (id) => {
    return `/charge-approval-work-orders/${id}`;
  },
  WORK_ORDER_STATION_LOG: '/workorders-station-log',
  LOGS: '/logs',
  EMPLOYEE_KPI: '/employee-kpi',
  EMPLOYEE_KPI_ID: (id) => {
    return `/employee-kpi/${id}`;
  },
  // reports
  REPORT_CONTRACT: '/reports/contract',
  REPORT_WORK_ORDER: '/reports/work-order',
  REPORT_UNIT: '/reports/unit',
  REPORT_ITEM: '/reports/unit',
  REPORT_VENDOR: '/reports/vendor',
  REPORT_REQUEST_ITEM: '/reports/request-item',
  REPORT_VOUCHER_RECORD: '/reports/voucher-record',
  REPORT_VOUCHER_SUM: '/reports/voucher-sum',
  REPORT_INVOICE: '/reports/invoice',
  REPORT_PURCHASE_ORDER: '/reports/purchase-order',
  REPORT_PAYROLL: '/reports/payroll',
  REQUEST_ITEM_APPROVAL: '/request-item-approval',
  REQUEST_ITEM_APPROVAL_ID: (id) => {
    return `/request-item-approval/${id}`;
  },
  REPORT_CLASSIFICATION: '/reports/classification',
  REPORT_DEPARTMENT: '/reports/department',
  REPORT_GRADE: '/reports/grade',
  REPORT_EMPLOYEE_EXPIRE: '/reports/employee-expire',
  REPORT_EMPLOYEE: '/reports/employee',
  REPORT_EMPLOYEE_DEPARTMENT: '/reports/employee-department',
  REPORT_EMPLOYEE_GRADE: '/reports/employee-grade',
  REPORT_EMPLOYEE_CLASSIFICATION: '/reports/employee-classification',
};
